import { PageWrapper } from '@Component/Page/Page';
import {
    Onboarding,
    OnboardingContent,
    OnboardingSidebar,
    OnboardingSidebarWelcome,
    OnboardingSidebarWelcomeImage,
    OnboardingSidebarWelcomeTitle,
    OnboardingStage,
    StageState,
    useOnboardingContext,
} from '@tlx/beehive-shared';
import React, { useEffect } from 'react';
import { ConnectedVacationPayAndRateStage } from '@Page/Onboarding/steps/VacationPayAndRateStage';

import { ConnectedActivateFunctionsStage } from '@Page/Onboarding/steps/ActivateFunctionsStage';
import { ConnectedNormalTimeStage } from '@Page/Onboarding/steps/NormalTimeStage';
import { ConnectedPaymentOfSalaryStage } from '@Page/Onboarding/steps/PaymentOfSalaryStage';
import { ConnectedPensionStage } from '@Page/Onboarding/steps/PensionStage';
import { TipsStage } from '@Page/Onboarding/steps/TipsStage';
import { useIntl } from 'react-intl';
import {
    SalaryOnboardingWithTips,
    useSalaryOnboardingPageOptionsContext,
} from '@Page/Onboarding/SalaryOnboardingWithTips';
import { SalaryOnboardingStep } from '@Page/Onboarding/hooks/useSalaryOnboardingPageOptions';

export function SalaryOnboarding() {
    const intl = useIntl();
    return (
        <PageWrapper>
            <SalaryOnboardingWithTips>
                <Onboarding data-trackingid="salary" variant={'inline'}>
                    <OnboardingSidebar>
                        <OnboardingSidebarWelcome>
                            <OnboardingSidebarWelcomeTitle>
                                {intl.formatMessage({
                                    id: 'tsk_onboarding_welcome_get_started',
                                })}
                            </OnboardingSidebarWelcomeTitle>
                            <OnboardingSidebarWelcomeImage
                                src={'imgs/money.svg'}
                                alt="money"
                                width="200px"
                                height="200px"
                            />
                        </OnboardingSidebarWelcome>
                    </OnboardingSidebar>
                    <OnboardingContent>
                        {/* <OnboardingStage
                            id="welcome"
                            title={intl.formatMessage({
                                id: 'text_onboarding_welcome',
                            })}
                        >
                            <WelcomeStage />
                        </OnboardingStage> */}
                        <OnboardingStage
                            id="PAYMENT_OF_SALARY"
                            title={intl.formatMessage({
                                id: 'text_salary_payments',
                            })}
                        >
                            <ConnectedPaymentOfSalaryStage />
                        </OnboardingStage>
                        <OnboardingStage
                            id="PENSION"
                            title={intl.formatMessage({
                                id: 'tsk_onboarding_pension_step',
                            })}
                        >
                            <ConnectedPensionStage />
                        </OnboardingStage>
                        <OnboardingStage
                            id="VACATION_PAY_AND_RATE"
                            title={intl.formatMessage({
                                id: 'tsk_onboarding_vacation_step',
                            })}
                        >
                            <ConnectedVacationPayAndRateStage />
                        </OnboardingStage>
                        <OnboardingStage
                            id="NORMAL_TIME"
                            title={intl.formatMessage({
                                id: 'text_standard_time',
                            })}
                        >
                            <ConnectedNormalTimeStage />
                        </OnboardingStage>
                        <OnboardingStage
                            id="ACTIVATE_FUNCTIONS"
                            title={intl.formatMessage({
                                id: 'tsk_onboarding_activate_feature_title',
                            })}
                        >
                            <ConnectedActivateFunctionsStage />
                        </OnboardingStage>
                        <OnboardingStage id="TIP" title="Tips">
                            <TipsStage />
                        </OnboardingStage>
                        <UpdateOnboardingStateOnMount />
                    </OnboardingContent>
                </Onboarding>
            </SalaryOnboardingWithTips>
        </PageWrapper>
    );
}

function UpdateOnboardingStateOnMount() {
    const { data } = useSalaryOnboardingPageOptionsContext();
    const { setStageState, activateStage, order } = useOnboardingContext();

    useEffect(() => {
        let hasActivatedStage = false;
        order.forEach((stageId) => {
            const completed = data?.completedSteps.includes(stageId as SalaryOnboardingStep);
            const skipped = data?.skippedSteps.includes(stageId as SalaryOnboardingStep);

            if (completed) {
                setStageState(stageId, StageState.Done);
            } else if (skipped) {
                setStageState(stageId, StageState.Done); //TODO if we get a skip state
            } else if (!hasActivatedStage) {
                activateStage(stageId);
                hasActivatedStage = true;
            }
        });
    }, [order]);

    return null;
}

export function SalaryGraph({ children }: { children: React.ReactNode }) {
    return (
        <div
            style={{
                maxWidth: 'max-content',
                background: 'linear-gradient(black 0 0)',
                backgroundSize: '1px',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
            className="atl-flex atl-flex-col atl-gap-32"
        >
            {children}
        </div>
    );
}
export function SalaryGraphItem({ children }: { children: React.ReactNode }) {
    return (
        <div className="atl-px-32 atl-py-16 atl-gap-12 atl-inline-flex atl-border atl-rounded atl-border-blue-120 atl-bg-blue-5 atl-items-center">
            {children}
        </div>
    );
}
